export class BlobUtils {
    static async blobToBuffer(blob) {
        const arrayBuffer = await blob.arrayBuffer();
        return Buffer.from(arrayBuffer);
    }
    static bufferToBlob(buffer) {
        return new Blob([buffer]);
    }
}
//# sourceMappingURL=blob-utils.js.map